/* ==========================================================================
   DAZI — product page improvements
   --------------------------------------------------------------------------
   This file does three small jobs on the product page:

     1. Keeps a plain-text "3 of 16" photo counter up to date, and marks
        which thumbnail is the current one, so that someone using a screen
        reader knows which photo they are looking at.
     2. Lets the thumbnails be operated with a keyboard.
     3. Shows a slim buy bar at the bottom of a phone screen once the real
        Add to Cart button has scrolled out of view.

   (The menu button at the top of every page is handled in custom.js, since
   that one is not specific to the product page.)

   It is written so that if anything is missing from the page, it simply does
   nothing rather than causing an error.
   ========================================================================== */

(function () {
  'use strict';

  /* Waits for the photo slider to finish setting itself up. The slider is
     created by the theme's own script, which may run after this one. */
  function whenSliderReady(callback) {
    var tries = 0;
    (function poll() {
      if (window.mainSwiper && window.mainSwiper.slides) {
        callback(window.mainSwiper);
        return;
      }
      if (tries++ > 60) {
        // The slider never appeared. Carry on without it.
        callback(null);
        return;
      }
      setTimeout(poll, 100);
    })();
  }

  /* ----------------------------------------------------------------------
     1 + 2. PHOTO COUNTER, CURRENT THUMBNAIL, AND KEYBOARD CONTROL
     ---------------------------------------------------------------------- */
  function setUpGallery(swiper) {
    var main = document.querySelector('.mainpdpslider');
    if (!main) return;

    var counter = document.querySelector('[data-dz-pdp-counter]');
    var thumbs = Array.prototype.slice.call(
      document.querySelectorAll('.thumb-mySwiper .dz-pdp-thumb')
    );
    var slides = Array.prototype.slice.call(
      main.querySelectorAll('.swiper-slide')
    );
    var total = slides.length;

    function currentIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('swiper-slide-active')) return i;
      }
      return 0;
    }

    function update() {
      var index = currentIndex();

      if (counter && total > 0) {
        counter.textContent = 'Photo ' + (index + 1) + ' of ' + total;
      }

      for (var i = 0; i < thumbs.length; i++) {
        // aria-current tells a screen reader which photo is showing. The
        // matching outline in the stylesheet shows the same thing visually,
        // so it is never colour alone.
        thumbs[i].setAttribute('aria-current', i === index ? 'true' : 'false');
      }
    }

    // Clicking a thumbnail already works through the slider itself, but this
    // makes it certain, and it is what makes the keyboard work too: a button
    // responds to Enter and Space on its own.
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        if (swiper && typeof swiper.slideTo === 'function') {
          swiper.slideTo(i);
        }
      });
    });

    // Watch for the slider changing photo, however it was changed — arrows,
    // a swipe, a thumbnail, or the keyboard.
    var observer = new MutationObserver(update);
    observer.observe(main, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    update();
  }

  // Copies the appearance of one button onto another. Only the look is
  // copied — size, position and behaviour are left alone.
  function matchTheRealButton(target, source) {
    if (!window.getComputedStyle) return;

    var look;
    try {
      look = window.getComputedStyle(source);
    } catch (e) {
      return;
    }
    if (!look) return;

    // A see-through background means the real button is styled some other
    // way, so the colour from the theme settings is kept instead.
    var background = look.backgroundColor;
    if (background && background !== 'transparent' && background.indexOf('rgba(0, 0, 0, 0)') === -1) {
      target.style.backgroundColor = background;
    }
    if (look.color) target.style.color = look.color;
    if (look.fontFamily) target.style.fontFamily = look.fontFamily;
    if (look.fontWeight) target.style.fontWeight = look.fontWeight;
    if (look.fontSize) target.style.fontSize = look.fontSize;
    if (look.letterSpacing && look.letterSpacing !== 'normal') {
      target.style.letterSpacing = look.letterSpacing;
    }
    if (look.textTransform) target.style.textTransform = look.textTransform;
    if (look.borderRadius) target.style.borderRadius = look.borderRadius;
  }

  /* ----------------------------------------------------------------------
     3. THE STICKY BUY BAR
     ---------------------------------------------------------------------- */
  function setUpStickyBar() {
    var bar = document.querySelector('.dz-pdp-stickybar');
    if (!bar) return;

    // The real Add to Cart button inside the product form. The bar does not
    // add to the cart itself — it presses this button — so the size that was
    // chosen, the quantity, and the shop's own cart behaviour all still
    // apply exactly as before.
    var form = document.querySelector('.pdp_new_styless .product_form form, .product_form form.shopify-product-form');
    var realButton =
      form &&
      form.querySelector(
        'button[name="add"], input[type="submit"], .AddtoCart, .add_to_cart, [type="submit"]'
      );

    if (!realButton) {
      bar.parentNode.removeChild(bar);
      return;
    }

    var barButton = bar.querySelector('.dz-pdp-stickybar__btn');
    if (barButton) {
      barButton.addEventListener('click', function () {
        realButton.click();
      });

      // Copy the look of the real Add to Cart button onto this one, so the
      // two are the same colour and the same lettering. Doing it this way
      // rather than writing the colour in by hand means they stay matched
      // even if the shop's button colour is changed later on.
      matchTheRealButton(barButton, realButton);

      // Web fonts and any late-loading styles can land a moment after the
      // rest of the page, so the look is checked once more when everything
      // has finished loading.
      window.addEventListener('load', function () {
        matchTheRealButton(barButton, realButton);
      });
    }

    // Keep the price in the bar matching the price shown on the page, so it
    // stays correct if a different size is chosen.
    var barPrice = bar.querySelector('[data-dz-pdp-sticky-price]');
    var pagePrice = document.querySelector('.price_new_pdp');
    if (barPrice && pagePrice) {
      // Only the price the shopper actually pays goes in the bar. The price
      // block on the page can also hold the old "compare at" price and a
      // hidden per-unit line, and running them together read as
      // "$8.00$32.00|/", so both are skipped here.
      var copyPrice = function () {
        var text = '';
        var current = pagePrice.querySelector('.current_price .money');
        if (current) text = current.textContent;

        if (!text.replace(/\s+/g, '').length) {
          var monies = pagePrice.querySelectorAll('.money');
          for (var i = 0; i < monies.length; i++) {
            var m = monies[i];
            if (m.closest && (m.closest('.was_price') || m.closest('.product-details__unit-price'))) continue;
            if (m.textContent.replace(/\s+/g, '').length) {
              text = m.textContent;
              break;
            }
          }
        }

        text = text.replace(/\s+/g, ' ').trim();
        if (text) barPrice.textContent = text;
      };
      copyPrice();
      new MutationObserver(copyPrice).observe(pagePrice, {
        subtree: true,
        childList: true,
        characterData: true
      });
    }

    var shown = false;

    function show() {
      if (shown) return;
      shown = true;
      bar.hidden = false;
      document.body.classList.add('dz-pdp-has-stickybar');
      // Reserve exactly as much room at the foot of the page as the bar
      // actually takes up, so the last line of content is never covered.
      var barHeight = bar.offsetHeight;
      if (barHeight) document.body.style.paddingBottom = barHeight + 'px';
      // A moment's delay so the browser registers the bar before it slides
      // up, otherwise it would just appear instantly.
      window.requestAnimationFrame(function () {
        bar.classList.add('is-shown');
      });
    }

    function hide() {
      if (!shown) return;
      shown = false;
      bar.classList.remove('is-shown');
      document.body.classList.remove('dz-pdp-has-stickybar');
      document.body.style.paddingBottom = '';
      // Wait for the slide-down to finish before taking it out of the page,
      // so it does not vanish mid-movement.
      window.setTimeout(function () {
        if (!shown) bar.hidden = true;
      }, 240);
    }

    function isPhone() {
      return window.matchMedia('(max-width: 798px)').matches;
    }

    if ('IntersectionObserver' in window) {
      var watcher = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!isPhone()) {
            hide();
            return;
          }
          // Show the bar once the real button has scrolled up out of sight.
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            show();
          } else {
            hide();
          }
        },
        { threshold: 0 }
      );
      watcher.observe(realButton);
    }

    // If the window is resized onto a desktop, put the bar away.
    window.addEventListener('resize', function () {
      if (!isPhone()) hide();
    });
  }

  function init() {
    setUpStickyBar();
    whenSliderReady(setUpGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
